import React from 'react';

import PropTypes from 'prop-types';

import global from '@src/css/global.scss';

export const NewKeyword = (props) => {
    const { children } = props;

    if (children) {
        return <span><span className={global.met_new_keyword_color}>NEW! </span>{children}</span>;
    }

    return (
        <span className={global.met_new_keyword_color}>NEW! </span>
    );
};

NewKeyword.propTypes = {
    children: PropTypes.node,
};
